// CTA Banner: headline card slides in from the left, secondary area from the right,
// then the button fades in and scales up.
document.addEventListener( 'DOMContentLoaded', () => {
	const banners = Array.from( document.querySelectorAll( '.cta-banner-block' ) );
	if ( ! banners.length ) return;

	const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

	banners.forEach( ( banner ) => {
		const card      = banner.querySelector( '.cta-headline-card' );
		const secondary = banner.querySelector( '.cta-secondary-area' );
		const btn       = banner.querySelector( '.cta-btn' );

		if ( card ) {
			card.style.opacity    = '0';
			card.style.transform  = 'translateX(-48px) translateY(16px)';
			card.style.transition = `opacity 0.8s ${ EASING }, transform 0.8s ${ EASING }`;
		}
		if ( secondary ) {
			secondary.style.opacity    = '0';
			secondary.style.transform  = 'translateX(48px)';
			secondary.style.transition = `opacity 0.8s ${ EASING } 0.15s, transform 0.8s ${ EASING } 0.15s`;
		}
		if ( btn ) {
			btn.style.opacity    = '0';
			btn.style.transform  = 'scale(0.85)';
			btn.style.transition = `opacity 0.5s ${ EASING } 0.65s, transform 0.5s ${ EASING } 0.65s`;
		}
	} );

	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( ! entry.isIntersecting ) return;

				const banner    = entry.target;
				const card      = banner.querySelector( '.cta-headline-card' );
				const secondary = banner.querySelector( '.cta-secondary-area' );
				const btn       = banner.querySelector( '.cta-btn' );

				if ( card )      { card.style.opacity = '1';      card.style.transform = 'translateX(0) translateY(0)'; }
				if ( secondary ) { secondary.style.opacity = '1'; secondary.style.transform = 'translateX(0)'; }
				if ( btn )       { btn.style.opacity = '1';       btn.style.transform = 'scale(1)'; }

				// After the intro animation completes, replace the delayed transition with
				// a clean one so hover interactions (color + scale) fire simultaneously.
				if ( btn ) {
					setTimeout( () => {
						btn.style.transition = `background-color 0.25s ease, transform 0.25s ease, box-shadow 0.25s ease`;
					}, 1150 ); // 0.65s delay + 0.5s duration
				}

				observer.unobserve( banner );
			} );
		},
		{ threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
	);

	banners.forEach( ( banner ) => observer.observe( banner ) );

	// Button hover colour swap using the data attribute set in render.php.
	document.querySelectorAll( '.cta-btn[data-hover-color]' ).forEach( ( btn ) => {
		const original = btn.style.backgroundColor;
		const hover    = btn.dataset.hoverColor;
		btn.addEventListener( 'mouseenter', () => {
			btn.style.transform       = 'scale(1.05)';
			btn.style.backgroundColor = hover;
			btn.style.boxShadow       = '0 8px 24px rgba(0,0,0,0.18)';
		} );
		btn.addEventListener( 'mouseleave', () => {
			btn.style.transform       = 'scale(1)';
			btn.style.backgroundColor = original;
			btn.style.boxShadow       = '';
		} );
	} );
} );
